module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "width": "100%",
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "row row-mobile"
  }, [_c('div', {
    staticClass: "mobile-header-menu"
  }, [(_vm.isSearch) ? _c('v-col', {
    staticClass: "search-bar",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-dots-vertical")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isSearch) ? _c('div', {
    staticClass: "hamburger hamburger--boring",
    on: {
      "click": function($event) {
        _vm.$refs.drov.droverMenu = true
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header-logo-and-images"
  }, [(!_vm.isSearch) ? _c('div', {
    staticClass: "header-logo"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header-image-search"
  }, [(!_vm.isSearch) ? _c('div', {
    staticClass: "share"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), (!_vm.isSearch) ? _c('div', {
    staticClass: "header-image__phone"
  }, [_c('a', {
    staticClass: "phone-mobile-header",
    attrs: {
      "href": "tel:89281771226",
      "route": "ignore"
    }
  }, [_vm._v(" 8-928-177-12-26 ")])]) : _vm._e()])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "header-items"
  }, [(_vm.isSearch) ? _c('v-row', [_c('v-col', {
    staticClass: "search-bar"
  }, [_c('v-autocomplete', {
    staticClass: "mx-4",
    attrs: {
      "clearable": "",
      "loading": _vm.loading,
      "items": _vm.itemsSearch,
      "search-input": _vm.search,
      "cache-items": "",
      "flat": "",
      "hide-no-data": "",
      "hide-details": "",
      "label": "введите поисковый запрос",
      "solo-inverted": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      }
    },
    model: {
      value: (_vm.select),
      callback: function($$v) {
        _vm.select = $$v
      },
      expression: "select"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-dots-vertical")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isSearch) ? _c('v-row', {
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "header-search-location"
  }, [_c('div', {
    staticClass: "header-location"
  }, [_c('div', {
    staticClass: "header-location__item"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/geolocation.png"
    }
  }), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "8"
    }
  }, [(_vm.getCityList) ? _c('v-select', {
    attrs: {
      "items": _vm.getCityList,
      "item-text": "name",
      "item-value": "domain",
      "single-line": "",
      "dense": ""
    },
    on: {
      "change": _vm.changeCity
    },
    model: {
      value: (_vm.currentCity),
      callback: function($$v) {
        _vm.currentCity = $$v
      },
      expression: "currentCity"
    }
  }) : _vm._e()], 1)], 1)])])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "header-logo"
  }, [_c('div', {
    staticClass: "header-logo__image"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/logoNewLife.svg"
    }
  })])])])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "header-number"
  }, [_c('div', {
    staticClass: "header-number__item"
  }, [_c('div', {
    staticClass: "header-number__phone"
  }, [_c('a', {
    attrs: {
      "route": "ignore",
      "href": "tel:89281771226"
    }
  }, [_c('img', {
    attrs: {
      "route": "ignore",
      "src": "/static/images/phone.png"
    }
  })]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "route": "ignore",
      "href": "tel:89281771226"
    }
  }, [_vm._v("\n                                        8 928 177 12 26\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "header-number-button"
  }, [_c('div', [_c('button', {
    staticClass: "header-number-button__ring",
    on: {
      "click": function($event) {
        _vm.$refs.mod.dialogСallCons = true
      }
    }
  }, [_vm._v("\n                                        Заказать звонок\n                                    ")])])])])])])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('nav', {
    staticClass: "header-bottom-menu"
  }, [_c('ul', {
    staticClass: "header-bottom-list"
  }, [(_vm.getTemplate) ? _c('div', {
    class: _vm.getUser ? 'row isEdit' : 'row',
    domProps: {
      "innerHTML": _vm._s(_vm.getTemplate.hb8)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getTemplate.hb8, 'hb8')
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('Drower', {
    ref: "drov"
  }), _vm._v(" "), _c('Modal', {
    ref: "mod"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hamburger-box"
  }, [_c('div', {
    staticClass: "hamburger-inner"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-logo__image"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/logoNewLife.svg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://wa.me/+79281771226",
      "target": "_blank",
      "route": "ignore"
    }
  }, [_c('i', {
    staticClass: "fab fa-whatsapp fa-2x",
    attrs: {
      "route": "ignore"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ed54733","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/header.vue
// module id = 134
// module chunks = 2